import { restClient } from '@/Core'

import { REQUEST_REST_URL } from '../Contracts/IRequest'

import type { RequestCollectionResponse, RequestRecord } from '../Contracts/IRequest'

export interface LoadClientRequestsParams {
    clientUuid: string
    page: number
    pageSize: number
}

/**
 * Сторінка запитів одного клієнта для вкладки «Запити» його картки
 * (`SPEC-025` §3.5): `filters` ядра з умовою `client.uuid`, порядок — як у
 * реєстрі (бек сортує за датою зміни). Права рядка (R-R) накладає бек — менеджер
 * бачить у вкладці лише свої запити, як і в реєстрі.
 *
 * `forceRefresh`: ядровий клієнт кешує GET, а після збереження запиту в
 * шухляді список мусить показати зміну.
 */
export const LoadClientRequestsTask = async ({
    clientUuid,
    page,
    pageSize,
}: LoadClientRequestsParams): Promise<{ items: RequestRecord[]; total: number }> => {
    const filters = encodeURIComponent(JSON.stringify({ and: [{ field: 'client.uuid', op: '=', value: clientUuid }] }))
    const raw = await restClient.get(
        `${REQUEST_REST_URL}?page=${page}&limit=${pageSize}&filters=${filters}`,
        undefined,
        { forceRefresh: true }
    )
    const data = raw as unknown as RequestCollectionResponse | null
    const items = (data?.items ?? []).filter((item) => typeof item?.uuid === 'string')
    const total = typeof data?.meta?.total === 'number' ? data.meta.total : items.length

    return { items, total }
}
